import { Button, ButtonProps } from "@chakra-ui/react";
import { CollecticonDownload2 } from "@devseed-ui/collecticons-chakra";
import { FeatureCollection, Point } from "geojson";

import { InferenceProperties } from "../types/inferences";
import { useDownload } from "../hooks";

type DownloadDetectionsProps = {
  inferences: FeatureCollection<Point, InferenceProperties> | undefined;
  fileName: string;
} & ButtonProps;

function DownloadDetections({
  children,
  inferences,
  fileName,
  ...props
}: DownloadDetectionsProps) {
  const { downloadLink } = useDownload(inferences);
  return (
    <Button
      rightIcon={<CollecticonDownload2 />}
      as="a"
      href={!props.isDisabled && downloadLink}
      download={fileName}
      {...props}
    >
      { children }
    </Button>
  );
}

export default DownloadDetections;
